// Static, mathematically correct divisibility explanations for divisors 2-9.
export const DIVISIBILITY_RULES = {
  2: {
    title: "Divisible by 2",
    rule: "A number is divisible by 2 when its last digit is even (0, 2, 4, 6 or 8).",
    example: "24,318 ends in 8, which is even — so it's divisible by 2.",
  },
  3: {
    title: "Divisible by 3",
    rule: "A number is divisible by 3 when the sum of its digits is divisible by 3.",
    example: "51,234 → 5+1+2+3+4 = 15, and 15 is divisible by 3.",
  },
  4: {
    title: "Divisible by 4",
    rule: "A number is divisible by 4 when its last two digits form a number divisible by 4.",
    example: "37,916 → the last two digits are 16, and 16 ÷ 4 = 4.",
  },
  5: {
    title: "Divisible by 5",
    rule: "A number is divisible by 5 when it ends in 0 or 5.",
    example: "84,120 ends in 0 — so it's divisible by 5.",
  },
  6: {
    title: "Divisible by 6",
    rule: "A number is divisible by 6 when it is divisible by both 2 and 3.",
    example: "51,234 is even (ends in 4) and its digits sum to 15 (÷3) — so it's divisible by 6.",
  },
  7: {
    title: "Divisible by 7",
    rule: "Double the last digit and subtract it from the number formed by the remaining digits. If the result is divisible by 7 (0 counts), the whole number is too. Repeat if needed.",
    example: "203 → 20 − (2 × 3) = 14, and 14 ÷ 7 = 2. So 203 is divisible by 7.",
  },
  8: {
    title: "Divisible by 8",
    rule: "A number is divisible by 8 when its last three digits form a number divisible by 8.",
    example: "17,320 → the last three digits are 320, and 320 ÷ 8 = 40.",
  },
  9: {
    title: "Divisible by 9",
    rule: "A number is divisible by 9 when the sum of its digits is divisible by 9.",
    example: "52,344 → 5+2+3+4+4 = 18, and 18 is divisible by 9.",
  },
};

export const WIN_MESSAGES = {
  1: "Unreal.",
  2: "Brilliant.",
  3: "Sharp.",
  4: "Nice one.",
  5: "Just in time.",
};

export const LOSE_MESSAGE = "Better luck tomorrow.";
